import { render, staticRenderFns } from "./realtimeOrder.vue?vue&type=template&id=fc26d59a&scoped=true&"
import script from "./realtimeOrder.vue?vue&type=script&lang=ts&"
export * from "./realtimeOrder.vue?vue&type=script&lang=ts&"
import style0 from "./realtimeOrder.vue?vue&type=style&index=0&id=fc26d59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc26d59a",
  null
  
)

export default component.exports